<template>
  <!-- eslint-disable max-len -->
  <div class="notifications-drop-down-menu">
    <mj-drop-down
      ref="notificationsDropDown"
      direction="right"
    >
      <button
        class="relative focus:outline-none focus:bg-indigo-800 p-2 rounded-lg"
        @click="showCollabsibleContent"
      >
        <mj-icon
          src="notification"
          class="w-8 h-8 fill-current text-indigo-600 relative"
        />
        <span
          v-if="unreadedNotifications.length > 0"
          class="notification__counter"
        >
          {{ unreadedNotifications.length }}
        </span>
      </button>
      <template #collapsible>
        <div
          class="w-64 text-left bg-white text-gray-700 font-semibold rounded-lg overflow-hidden text-sm shadow-lg"
        >
          <div
            class="notification__items py-1 overflow-y-auto h-full"
          >
            <template v-if="notificationsSlice.length > 0">
              <transition-group
                enter-active-class="transition-all transition-slowest ease-in-out"
                leave-active-class="transition-all transition-slowest ease-in-out"
                enter-class="opacity-0 slide-left"
                enter-to-class="opacity-100 slide-right"
                leave-class="opacity-100 slide-right"
                leave-to-class="opacity-0 slide-left"
              >
                <div
                  v-for="notification in notificationsSlice"
                  :key="notification.id"
                  class="notification__item flex px-4 py-3 leading-tight border-b-2 border-gray-200 hover:bg-indigo-100"
                >
                  <div class="mr-2 flex-auto">
                    <h5 class="notification__title mb-1 text-gray-900">
                      {{ notification.data.title }}.
                    </h5>
                    <p class="notification__description mb-3">
                      {{ notification.data.description }}
                    </p>
                    <p class="notification__date text-xs text-gray-500">
                      {{ formatDate(notification.created_at) }}
                    </p>
                  </div>
                  <div class="flex-shrink-0 w-4">
                    <span
                      class="notification__action"
                      :class="{ 'notification__action--is-unread' : !notification.read_at}"
                      @click="handleNotificationAction(notification)"
                    />
                  </div>
                </div>
              </transition-group>
            </template>
            <template v-else>
              <div class="notification__item flex px-4 py-3 leading-tight text-sm border-b-2 border-gray-200">
                Keine Benachrichtigungen.
              </div>
            </template>
          </div>
          <!-- <div class="actions py-1">
            <button
              class="block w-full px-6 py-3 text-left font-semibold outline-none hover:bg-indigo-100 focus:outline-none"
            >
              Alle Benachrichtigungen
            </button>
          </div> -->
        </div>
      </template>
    </mj-drop-down>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  format, formatDistanceToNow, differenceInHours,
} from 'date-fns';
import { de } from 'date-fns/locale';

import DropDown from '@/components/ui/general/dropdown/DropDown.vue';

export default {
  name: 'NotificationsDropDownMenu',

  components: {
    'mj-drop-down': DropDown,
  },

  computed: {
    ...mapGetters(['notifications']),

    unreadedNotifications() {
      return this.notifications.filter(notification => !notification.read_at);
    },

    notificationsSlice() {
      return this.notifications.slice(0, 10);
    },

  },

  methods: {
    ...mapActions(['readNotification']),

    formatDate(dateTimeString) {
      const ISODateTime = dateTimeString.replace(/\s+/g, 'T');
      if (differenceInHours(new Date(), new Date(ISODateTime)) >= 41) {
        return format(new Date(ISODateTime), 'dd.MM.YYY - hh:mm');
      }
      return formatDistanceToNow(new Date(ISODateTime), { locale: de });
    },

    showCollabsibleContent() {
      this.$refs.notificationsDropDown.$data.isOpen = true;
    },

    closeCollabsibleContent() {
      this.$refs.notificationsDropDown.$data.isOpen = false;
    },

    handleNotificationAction(notification) {
      this.readNotification(notification.id);
    },

  },
};

</script>

<style lang="scss" scoped>

.notification {

  &__counter {
    @apply absolute;
    top: .43rem;
    right: .31rem;
    @apply bg-pink-600;
    font-size: .6rem;
    @apply w-4;
    @apply h-4;
    @apply flex;
    @apply items-center;
    @apply justify-center;
    @apply text-center;
    @apply rounded-full;
    @apply font-black;
    animation: pulse 2s infinite;
  }

  &__items {
    max-height: 25rem;
  }

  &__item {
    &:last-child {
      border: none;
    }
  }

  &__action {
    @apply inline-block;
    @apply w-2;
    @apply h-2;
    @apply rounded-full;
    @apply bg-gray-500;

    &--is-unread {
      @apply bg-pink-600;
      @apply cursor-pointer;
      animation: pulse 2s infinite;

      &:hover {
        animation: none;
      }
    }

  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(251,157,177, 0.4);
  }
  70% {
      box-shadow: 0 0 0 10px rgba(251,157,177, 0);
  }
  100% {
      box-shadow: 0 0 0 0 rgba(251,157,177, 0);
  }
}

</style>
